// extracted by mini-css-extract-plugin
module.exports = {"amber":"marketmeta_amber__3jOm2","green":"marketmeta_green__2H8-z"};